import type { PayloadAction } from '@reduxjs/toolkit';

import type {
  EndFunctionCreatePayload,
  StartFunctionCreatePayload,
} from '@polyai/stream/commands/handlers/special-functions/create-function/schema';
import { createReferenceAdapter } from '@polyai/stream/store/references';

import { assignMetadata } from '../../utils/assign-metadata';
import { parametersAdapter } from '../flows';
import type { FunctionParameter } from '../functions/types';
import type { SpecialFunction, SpecialFunctionReferences } from './types';

const references: SpecialFunctionReferences[] = ['variables'];

export const specialFunctionsReferencesAdapter =
  createReferenceAdapter(references);

export const createSpecialFunctionWithEntityStates = (
  action:
    | PayloadAction<EndFunctionCreatePayload>
    | PayloadAction<StartFunctionCreatePayload>,
  functionPayload: StartFunctionCreatePayload | EndFunctionCreatePayload,
): SpecialFunction => {
  // Parameters
  const parameters = parametersAdapter.getInitialState(
    {},
    functionPayload.parameters?.map(p => {
      const newParam: FunctionParameter = {
        ...p,
        createdAt: '',
        createdBy: '',
        updatedAt: '',
        updatedBy: '',
      };
      assignMetadata(action, newParam);
      return newParam;
    }),
  );

  const newFunction: SpecialFunction = {
    ...functionPayload,
    parameters,
    references: specialFunctionsReferencesAdapter.createInitialState(
      functionPayload.references,
    ),
    createdAt: '',
    createdBy: '',
    updatedAt: '',
    updatedBy: '',
  };

  assignMetadata(action, newFunction);

  return newFunction;
};
